module.exports = __webpack_public_path__ + "static/media/qut.e54b3aa8.jpg";